import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useUserData } from '@/User/ui/context'

declare const window: any

export const MedalliaTag = (): null => {
  const { user, merchant } = useUserData()
  const location = useLocation()

  const appendScript = (): void => {
    const scriptId = "medallia-script";
    if (document.getElementById(scriptId)) return;

    const script = document.createElement('script')
    script.id = scriptId;
    script.src = "https://nebula-cdn.kampyle.com/eu/we/1109520/onsite/embed.js";
    script.type = 'text/javascript'
    script.async = true;

    document.body.appendChild(script)

    // Wait for the SDK to initialize, then trigger page view evaluation
    let attempts = 0
    const interval = setInterval(() => {
      attempts++
      if (window.KAMPYLE_ONSITE_SDK?.updatePageView) {
        window.KAMPYLE_ONSITE_SDK.updatePageView()
        if (window.KampyleSurvey) {
          window.KampyleSurvey.showForm && window.KampyleSurvey.showForm()
        } else if (window.Medallia) {
          window.Medallia('show')
        }
        clearInterval(interval)
      } else if (attempts >= 50) {
        clearInterval(interval)
      }
    }, 200)
  }

  const updateMedalliaPageView = () => {
    if (
      window.KAMPYLE_ONSITE_SDK &&
      typeof window.KAMPYLE_ONSITE_SDK.updatePageView === 'function'
    ) {
      window.KAMPYLE_ONSITE_SDK.updatePageView()
    }
  }

  const setSegementation = () => {
    if (merchant?.isMasterGroup) {
      return 'Master'
    }
    if (merchant?.isIndependent) {
      return 'Independiente'
    }
    if (merchant?.isParent) {
      return 'Grupo'
    }
    return 'No segmentado'
  }

  const setEnvironment = () => {
    if (import.meta.env.MODE === 'production') {
      return 'prod'
    }
    if (import.meta.env.MODE === 'staging') {
      return 'stage'
    }
    return 'dev'
  }

  const setMedalliaData = () => {
    !window.medalliaData && (window.medalliaData = {})

    window.medalliaData = {
      partnerName: merchant?.name || '',
      partnerId: merchant?.id || '',
      userName: user?.user?.name || '',
      userEmail: user?.user?.email || '',
      segmentation: setSegementation(),
      environment: setEnvironment(),
      country: 'Spain',
    }
  }

  useEffect(() => {
    if (!user || !merchant) return
    setMedalliaData()
    appendScript()
  }, [user, merchant])

  useEffect(() => {
    if (!user || !merchant) return
    setMedalliaData()
    updateMedalliaPageView()
  }, [location])

  return null
}
